import Title from "../elements/Title";
import { AdviseLabels } from "../enums/MessageEnum";

import logoBiblioMetro from "../assets/img/public/logo-biblio-metro.png"
import logoCgr from "../assets/img/public/logo-cgr.png"
import logoCorfo from "../assets/img/public/logo-corfo.png"
import logoMinju from "../assets/img/public/logo-minju.png"
import logoMinvu from "../assets/img/public/logo-minvu.png"
import logoSernatur from "../assets/img/public/logo-sernatur.png"
import logoBiblioNac from "../assets/img/public/logo_biblioteca_nacional.png"
import logoMinEn from "../assets/img/public/logo_ministerio_energia.png"
import ImageSlider from "../elements/ImageSlider";

import logoAfpHabitat from "../assets/img/private/logo-afp-habitat.png"
import logoArtel from "../assets/img/private/logo-artel.png"
import logoAtlas from "../assets/img/private/logo-atlas.png"
import logoBancoBice from "../assets/img/private/logo-bancobice.png"
import logoBciSeguros from "../assets/img/private/logo-bci-seguros.png"
import logoBiceVida from "../assets/img/private/logo-bicevida.png"
import logoCajaDeLosAndes from "../assets/img/private/logo-caja-los-andes.png"
import logoCgeElect from "../assets/img/private/logo-cge-elect.png"
import logoClaro from "../assets/img/private/logo-claro.png"
import logoEfeSolar from "../assets/img/private/logo-efe-solar.png"
import logoEquifax from "../assets/img/private/logo-equifax.png"
import logoFactoring from "../assets/img/private/logo-factoring.png"
import logoFallabella from "../assets/img/private/logo-falabella.png"
import logoGMO from "../assets/img/private/logo-gmo.png"
import logoGrupoAXO from "../assets/img/private/logo-axo.png"
import logoIBM from "../assets/img/private/logo-ibm.png"
import logoLaAraucana from "../assets/img/private/logo-la-araucana.png"
import logoParis from "../assets/img/private/logo-paris.png"
import logoPragma from "../assets/img/private/logo-pragma.png"
import logoPrevired from "../assets/img/private/logo-previred.png"
import logoPromanet from "../assets/img/private/logo-promanet.png"
import logoRezebra from "../assets/img/private/logo-rezebra.png"
import logoSice from "../assets/img/private/logo-sice.png"
import logoSiemens from "../assets/img/private/logo-siemens.png"
import logoSodimac from "../assets/img/private/logo-sodimac.png"
import logoTelecheque from "../assets/img/private/logo-telecheque.png"
import logoVerisure from "../assets/img/private/logo-verisure.png"

import logoAWS from "../assets/img/partners/partner-aws.png"
import logoNexsys from "../assets/img/partners/partner-nexsys.png"
import logoMongo from "../assets/img/partners/partner-mongo.png"
import logoWsystems from "../assets/img/partners/partner-wsystems.png"
import logoPragmaPartner from "../assets/img/partners/partner-logo-pragma.png"
export default function Clients(){

    const publicEntities = [
        {
            name: "Contraloría General de la República de Chile",
            src: logoCgr
        },
        {
            name: "Biblio Metro",
            src: logoBiblioMetro
        },
        {
            name: "Corfo",
            src: logoCorfo
        },
        {
            name: "Ministerio de Justicia",
            src: logoMinju
        },
        {
            name: "Ministerio de Vivienda y Urbanismo",
            src: logoMinvu
        },
        {
            name: "Sernatur",
            src: logoSernatur
        },
        {
            name: "Biblioteca Nacional",
            src: logoBiblioNac
        },
        {
            name: "Ministerio de Energía",
            src: logoMinEn
        }
    ]

    const privateEntities = [
        {
            name: "AFP Habitat",
            src: logoAfpHabitat
        },
        {
            name: "Artel",
            src: logoArtel
        },
        {
            name: "Atlas",
            src: logoAtlas
        },
        {
            name: "Banco Bice",
            src: logoBancoBice
        },
        {
            name: "BCI Seguros",
            src: logoBciSeguros
        },
        {
            name: "Bicevida",
            src: logoBiceVida
        },
        {
            name: "Caja Los Andes",
            src: logoCajaDeLosAndes
        },
        {
            name: "Claro",
            src: logoClaro
        },
        {
            name: "CGE Elect",
            src: logoCgeElect
        },
        {
            name: "Efe Solar",
            src: logoEfeSolar
        },
        {
            name: "Equifax",
            src: logoEquifax
        },
        {
            name: "Fallabella",
            src: logoFallabella
        },
        {
            name: "GMO",
            src: logoGMO
        },
        {
            name: "Grupo AXO",
            src: logoGrupoAXO
        },
        {
            name: "IBM",
            src: logoIBM
        },
        {
            name: "La Aracauna",
            src: logoLaAraucana
        },
        {
            name: "Paris",
            src: logoParis
        },
        {
            name: "Pragma",
            src: logoPragma
        },
        {
            name: "Previred",
            src: logoPrevired
        },
        {
            name: "Promanet",
            src: logoPromanet
        },
        {
            name: "Rezebra",
            src: logoRezebra
        },
        {
            name: "Sice",
            src: logoSice
        },
        {
            name: "Siemens",
            src: logoSiemens
        },
        {
            name: "Sodimac",
            src: logoSodimac
        },
        {
            name: "Telcheque",
            src: logoTelecheque
        },
        {
            name: "Telefonica Factoring",
            src: logoFactoring
        },
        {
            name: "Verisure",
            src: logoVerisure
        }
    ]

    const partnerEntities = [

        {
            name: "Amazon Web Services",
            src: logoAWS
        },
        {
            name: "Nexsys",
            src: logoNexsys
        },
        {
            name: "Mongo DB",
            src: logoMongo
        },
        {
            name: "WSystems",
            src: logoWsystems
        },
        {
            name: "Pragma",
            src: logoPragmaPartner
        }
    ]

    return(
        <div id='clients' className="information-subsection bg-gray-150" style={{paddingBottom: 0}}>
            <Title title={AdviseLabels.CLIENTS_TITLE}/>
            <div className="clients-slider-container">
                <div className="clients-slider-item">
                    <ImageSlider data={publicEntities} title={AdviseLabels.CLIENTS_PUBLIC}/>
                </div>
                <div className="clients-slider-item">
                    <ImageSlider data={privateEntities} title={AdviseLabels.CLIENTS_PRIVATE}/> 
                </div>         
            </div>        
            <div className="information-subsection bg-gray-150">
                <h2 className="text-3xl text-advise-color font-bold leading-tight information-title">
                    {AdviseLabels.PARTNERS_TITLE}
                </h2>
                <div className="partner-container">
                    {
                        partnerEntities.map(function (partnerIndex, partnerValue){
                            return(
                                <img src={partnerIndex.src} className="partner-image" 
                                alt={partnerIndex.name} key={partnerValue}/>
                            )
                        })
                    }
                </div>       
            </div>
        </div>
    )
}